

// [BD feat] subascription js start here  :- https://prnt.sc/REZNFT3H86sG
(function() {
  'use strict';
  document.addEventListener("DOMContentLoaded", function () {
    const test1Radio = document.getElementById('test1');
    const addToCartBtn = document.querySelector('button[add-subscription-data]');

    if (test1Radio && addToCartBtn) {
      test1Radio.addEventListener('click', function () {
        addToCartBtn.setAttribute('add-subscription-data', '');
      });
    }
  });
})();


//  [BD feat] subascription js start here  :- https://prnt.sc/REZNFT3H86sG
(function() {
  'use strict';
  document.addEventListener('DOMContentLoaded', function() {
     setTimeout(() => {
      const targetBtn = document.querySelector("#sdev_target_btn1");
      if (targetBtn) {
        targetBtn.click();
      }
    }, 100);
    const einmaligerKaufRadio = document.getElementById('test1');
    const abonnementRadio = document.getElementById('test2');
    const planDaysContainer = document.querySelector('.select-product-plan-days');
    const planSelect = document.querySelector('select[name="selling_plan"]');
    const addToCartButton = document.querySelector('button[name="add"]');

    function togglePlanDropdown() {
      if (abonnementRadio && abonnementRadio.checked) {
        if (planDaysContainer) {
          planDaysContainer.style.display = 'block';
        }
        const select = document.querySelector('.custom-select');

        if (select) {
          const option30 = [...select.options].find(
            opt => opt.getAttribute('custom-data-plan') === "Delivery every 30 days"
          );

          if (option30) {
            option30.selected = true;
            const event = new Event('change', { bubbles: true });
            select.dispatchEvent(event);
          }
        }
      } else {
        if (planDaysContainer) {
          planDaysContainer.style.display = 'none';
        }
        if (addToCartButton) {
          addToCartButton.setAttribute('add-subscription-data', '');
          addToCartButton.setAttribute('custom_data_plan', '');
          addToCartButton.setAttribute('recharge_plan_id', '');
        }
        removeActiveClassFromAllRadios();
      }
    }

    function removeActiveClassFromAllRadios() {
      const radioButtons = document.querySelectorAll('input[type="radio"][recharge_plan_id]');
      radioButtons.forEach(radio => {
        radio.classList.remove('active');
        const parentBox = radio.closest('.choose_an_offer_box');
        if (parentBox) {
          parentBox.classList.remove('active');
        }
      });
    }

    function simulateClickOnMatchingRadio(rechargeplanId) {
      if (rechargeplanId) {
        const matchingRadio = document.querySelector(
          `input[type="radio"][recharge_plan_id="${rechargeplanId}"]`
        );
        if (matchingRadio) {
          matchingRadio.click();
          const parentBox = matchingRadio.closest('.choose_an_offer_box');
          if (parentBox) {
            const clickEvent = new Event('click', { bubbles: true, cancelable: true });
            parentBox.dispatchEvent(clickEvent);
          }
          console.log('Simulated click on radio and container with recharge_plan_id:', rechargeplanId);
        }
      }
    }

    function addActiveClassToMatchingRadio(rechargeplanId) {
      removeActiveClassFromAllRadios();
      if (rechargeplanId) {
        const matchingRadio = document.querySelector(
          `input[type="radio"][recharge_plan_id="${rechargeplanId}"]`
        );
        if (matchingRadio) {
          matchingRadio.classList.add('active');
          const parentBox = matchingRadio.closest('.choose_an_offer_box');
          if (parentBox) {
            parentBox.classList.add('active');
          }
          console.log('Added active class to radio with recharge_plan_id:', rechargeplanId);
        }
      }
    }

    function updateButtonAttributes() {
      if (planSelect && addToCartButton) {
        const selectedOption = planSelect.options[planSelect.selectedIndex];
        if (selectedOption && selectedOption.value !== 'Wähle deinen Plan') {
          const planValue = selectedOption.value;
          const customDataPlan = selectedOption.getAttribute('custom-data-plan') || '';

          addToCartButton.setAttribute('add-subscription-data', planValue);
          addToCartButton.setAttribute('custom_data_plan', customDataPlan);
          addToCartButton.setAttribute('recharge_plan_id', planValue);

          addActiveClassToMatchingRadio(planValue);
          simulateClickOnMatchingRadio(planValue);

          console.log('Button updated with:', {
            'add-subscription-data': planValue,
            'custom_data_plan': customDataPlan,
            'recharge_plan_id': planValue
          });
        } else {
          addToCartButton.setAttribute('add-subscription-data', '');
          addToCartButton.setAttribute('custom_data_plan', '');
          addToCartButton.setAttribute('recharge_plan_id', '');
          removeActiveClassFromAllRadios();
        }
      }
    }

    // ✅ Null-safe event bindings
    if (einmaligerKaufRadio) {
      einmaligerKaufRadio.addEventListener('change', togglePlanDropdown);
    }
    if (abonnementRadio) {
      abonnementRadio.addEventListener('change', togglePlanDropdown);
    }
    if (planSelect) {
      planSelect.addEventListener('change', updateButtonAttributes);
    }

    togglePlanDropdown();
  });
})();



// [BD feat]  Alternative approach using event delegation (more efficient for dynamic content) :- https://prnt.sc/eCAHvFzCF2-E
(function() {
  'use strict';
  document.addEventListener('change', function(event) {
    if (event.target.name === 'radio-group') {
        const planDaysContainer = document.querySelector('.select-product-plan-days');
        const addToCartButton = document.querySelector('button[name="add"]');

        if (event.target.getAttribute('data-value') === 'Abonnement') {
            planDaysContainer.style.display = 'block';
        } else if (event.target.getAttribute('data-value') === 'Einmaliger Kauf') {
            planDaysContainer.style.display = 'none';
            if (addToCartButton) {
                addToCartButton.setAttribute('add-subscription-data', '');
                addToCartButton.setAttribute('custom_data_plan', '');
                addToCartButton.setAttribute('recharge_plan_id', '');
            }
            const radioButtons = document.querySelectorAll('input[type="radio"][recharge_plan_id]');
            radioButtons.forEach(radio => {
                radio.classList.remove('active');
                const parentBox = radio.closest('.choose_an_offer_box');
                if (parentBox) {
                    parentBox.classList.remove('active');
                  document.querySelector('.choose_an_offer_pdp_page').classList.remove('recharge');
                }
            });
        }
    }
    if (event.target.name === 'selling_plan') {
        const addToCartButton = document.querySelector('button[name="add"]');
        const selectedOption = event.target.options[event.target.selectedIndex];

        if (selectedOption && addToCartButton && selectedOption.value !== 'Wähle deinen Plan') {
            const planValue = selectedOption.value;
            const customDataPlan = selectedOption.getAttribute('custom-data-plan') || '';
            addToCartButton.setAttribute('add-subscription-data', planValue);
            addToCartButton.setAttribute('custom_data_plan', customDataPlan);
            addToCartButton.setAttribute('recharge_plan_id', planValue);
            const radioButtons = document.querySelectorAll('input[type="radio"][recharge_plan_id]');
            radioButtons.forEach(radio => {
                radio.classList.remove('active');
                const parentBox = radio.closest('.choose_an_offer_box');
                if (parentBox) {
                    parentBox.classList.remove('active');
                    document.querySelector('.choose_an_offer_pdp_page').classList.remove('recharge');
                }
            });
            const matchingRadio = document.querySelector(`input[type="radio"][recharge_plan_id="${planValue}"]`);
            if (matchingRadio) {
                matchingRadio.classList.add('active');
                const parentBox = matchingRadio.closest('.choose_an_offer_box');
                if (parentBox) {
                    parentBox.classList.add('active');
                    document.querySelector('.choose_an_offer_pdp_page').classList.add('recharge');
                }
                matchingRadio.click();
                if (parentBox) {
                    const clickEvent = new Event('click', {
                        bubbles: true,
                        cancelable: true
                    });
                    parentBox.dispatchEvent(clickEvent);
                }

                console.log('Added active class and simulated click for radio with recharge_plan_id:', planValue);
            }

            console.log('Button updated with:', {
                'add-subscription-data': planValue,
                'custom_data_plan': customDataPlan,
                'recharge_plan_id': planValue
            });
        } else if (addToCartButton) {
            addToCartButton.setAttribute('add-subscription-data', '');
            addToCartButton.setAttribute('custom_data_plan', '');
            addToCartButton.setAttribute('recharge_plan_id', '');
            const radioButtons = document.querySelectorAll('input[type="radio"][recharge_plan_id]');
            radioButtons.forEach(radio => {
                radio.classList.remove('active');
                const parentBox = radio.closest('.choose_an_offer_box');
                if (parentBox) {
                    parentBox.classList.remove('active');
                   document.querySelector('.choose_an_offer_pdp_page').classList.remove('recharge');
                }
            });
        }
    }
});

 document.addEventListener('click', function(event) {
  const clickedBox = event.target.closest('.choose_an_offer_box');
  if (!clickedBox) return;

  const frequencyTime = clickedBox.getAttribute('frequency_time');
  const planPrice = clickedBox.getAttribute('plan_price');
  const planCompareAtPrice = clickedBox.getAttribute('plan_compare_at_price');

  const radio = clickedBox.querySelector('input[type="radio"][recharge_plan_id]');

  if (radio) {
    const ctaButton = document.querySelector(".custom-cta_button button");
    if (ctaButton) {
      ctaButton.setAttribute("frequency_time", frequencyTime);
    }

    console.log('Radio button recharge_plan_id:', radio.getAttribute('recharge_plan_id'), frequencyTime);

    const priceContainer = document.querySelector('[subscription-bundle-price]');
    const actualPriceContainer = document.querySelector('[actual-bundle-price]');

    if (priceContainer) {
      priceContainer.innerHTML = `
        <span style="text-decoration: line-through;">${planCompareAtPrice}</span>
        ${planPrice}
      `;
    }

    if (actualPriceContainer) {
      actualPriceContainer.innerHTML = planCompareAtPrice;
    }
  }
});

})();



// [BD feat] store itmes
(function() {
  'use strict';
  window.addEventListener("load", function () {
  const shouldRefresh = localStorage.getItem("goBackRefresh");

  if (shouldRefresh === "true") {
    localStorage.setItem("goBackRefresh", "false"); // reset it
    window.location.reload(); // force a reload
  }
});
})();



// [BD feat]  subscription on click selected data fecth: https://prnt.sc/47RFjVXrSV-x
(function() {
  'use strict';
  document.addEventListener("DOMContentLoaded", function () {
    const radios = document.querySelectorAll('input[name="radio-group"]');
    const targetBtn = document.querySelector('[add-subscription-data]');

    if (radios.length && targetBtn) {
      radios.forEach(radio => {
        radio.addEventListener('change', function() {
          const val = this.getAttribute('data-value') || '';
          targetBtn.setAttribute("choose_subscription", val);

        
          if (val === "Einmaliger Kauf") {
            targetBtn.setAttribute("recharge_plan_id", "");
            targetBtn.setAttribute("custom_data_plan", "");
            targetBtn.setAttribute("frequency_time", "");
          }
        });
      });

      const checkedRadio = document.querySelector('input[name="radio-group"]:checked');
      if (checkedRadio) {
        targetBtn.setAttribute("choose_subscription", checkedRadio.getAttribute("data-value"));
      }
    }

    
    document.body.addEventListener("click", function (event) {
      const button = event.target.closest("[add-subscription-data]");

      if (button) {
        event.preventDefault();

        const variantId = button.getAttribute("pass_variant-id");
        const sellingPlanId = button.getAttribute("recharge_plan_id");
        const customPlan = button.getAttribute("custom_data_plan");
        const frequency_time = button.getAttribute("frequency_time");
        const chooseSub = button.getAttribute("choose_subscription");

        const formData = {
          items: [{
            id: variantId,
            quantity: 1,
            properties: {}
          }]
        };

        
        if (chooseSub !== "Einmaliger Kauf") {
          if (sellingPlanId) {
            formData.items[0].selling_plan = sellingPlanId;
          } else if (frequency_time) {
            formData.items[0].properties['frequency_time'] = frequency_time;
          }
          if (customPlan) {
            formData.items[0].properties['Subscription Plan'] = customPlan;
          }
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
          console.log('Added to cart:', data);
          localStorage.setItem("goBackRefresh", "true");

          setTimeout(()=>{
            document.querySelector('[aria-controls="cart-drawer"]').click();

            fetch(`${Shopify.routes.root}?section_id=cart-drawer`)
            .then(response => response.text())
            .then(carthtml => {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = carthtml;

              const newCartDrawer = tempDiv.querySelector('cart-drawer');
              const existingCartDrawer = document.querySelector('cart-drawer');

              if (newCartDrawer && existingCartDrawer) {
                existingCartDrawer.innerHTML = newCartDrawer.innerHTML;
              }
            })
            .catch(error => {
              console.error('Error fetching cart drawer:', error);
            });
          },100);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
      }
    });
  });
})();



